module.exports = __webpack_public_path__ + "8cb05cc8693221f2eec147eb4f657c4f.svg";